import ConfigStatus from './ConfigStatus';

export default ConfigStatus;
